import { ProjectType, Module, AssetType, AssetSuperType } from 'app/shared/models';
import { Helpers } from 'app/shared/helpers';
import { ModuleEnum } from '@app/shared/data/project-enums';

export interface IAssetMappingConfiguration {
  AssetMappingConfigurationId: number;
  ProjectTypeId: number;
  AssetSuperTypeId: number | null;
  AssetTypeId: number | null;
  ModuleId: number;
  IsConstructedModule: boolean;
  IsSingleInstanceAsset: boolean;
  IsTankBatterySource: boolean;
  IsOwidEditable: boolean;
  IsWellReassignment: boolean;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;
  Sequence: number | null;
  IsAllowAllocation: boolean;

  AssetTypeFilters?: Array<IAssetTypeFilter>;
  ProjectStatusEditable?: Array<ProjectStatusEdit>;
  ModuleProperties?: ModuleProperties;

  AssetSuperType?: AssetSuperType;
  AssetType?: AssetType;
  Module?: Module;
  ProjectType?: ProjectType;
}

export class AssetMappingConfiguration {
  AssetMappingConfigurationId: number;
  ProjectTypeId: number;
  AssetSuperTypeId: number | null;
  AssetTypeId: number | null;
  ModuleId: number;
  IsConstructedModule: boolean;
  IsSingleInstanceAsset: boolean;
  IsTankBatterySource: boolean;
  IsOwidEditable: boolean;
  IsWellReassignment: boolean;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;
  Sequence: number | null;
  IsAllowAllocation: boolean;

  AssetTypeFilters?: Array<IAssetTypeFilter>;
  ProjectStatusEditable?: Array<ProjectStatusEdit>;
  ModuleProperties?: ModuleProperties;

  AssetSuperType?: AssetSuperType;
  AssetType?: AssetType;
  Module?: Module;
  ProjectType?: ProjectType;

  constructor(item?: any) {
    if (item) {
      let moduleProperties = new ModuleProperties();
      moduleProperties.Name = item.Module.Description;
      moduleProperties.Show = item.Sequence % 1 === 0 ? true : false;
      moduleProperties.IsToggleModule = item.Sequence % 1 === 0 ? false : true;

      //Check for General Asset or Multi Asset
      if ((item.ModuleId === ModuleEnum.Asset || item.ModuleId === ModuleEnum.MultiAsset) && item.AssetSuperType)
        moduleProperties.Name = `${moduleProperties.Name} - ${item.AssetSuperType.Description}`;

      this.AssetMappingConfigurationId = item.AssetMappingConfigurationId;
      this.ProjectTypeId = item.ProjectTypeId;
      this.AssetSuperTypeId = item.AssetSuperTypeId;
      this.AssetTypeId = item.AssetTypeId;
      this.ModuleId = item.ModuleId;
      this.IsConstructedModule = item.IsConstructedModule;
      this.IsSingleInstanceAsset = item.IsSingleInstanceAsset;
      this.IsTankBatterySource = item.IsTankBatterySource;
      this.IsOwidEditable = item.IsOwidEditable;
      this.IsWellReassignment = item.IsWellReassignment;
      this.Created = item.Created;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated;
      this.UpdatedBy = item.UpdatedBy;
      this.Sequence = item.Sequence;
      this.IsAllowAllocation = item.IsAllowAllocation;

      this.AssetTypeFilters = Helpers.createClassArray(AssetTypeFilter, JSON.parse(item.AssetTypeFilters));
      this.ProjectStatusEditable = Helpers.createClassArray(ProjectStatusEdit, JSON.parse(item.ProjectStatusEditable));
      this.ModuleProperties = moduleProperties;

      this.AssetSuperType = item.AssetSuperType;
      this.AssetType = item.AssetType;
      this.Module = item.Module;
      this.ProjectType = item.ProjectType;
    }
  }
}

export interface IAssetTypeFilter {
  AssetTypeId: number;
}

export interface IProjectStatusEdit {
  ProjectStatusId: number;
  ReadWrite: boolean;
}

export class AssetTypeFilter {
  AssetTypeId: number;

  constructor(item?: IAssetTypeFilter) {
    if (item) {
      this.AssetTypeId = item.AssetTypeId;
    }
  }
}

export class ProjectStatusEdit {
  ProjectStatusId: number;
  ReadWrite: boolean;

  constructor(item?: IProjectStatusEdit) {
    if (item) {
      this.ProjectStatusId = item.ProjectStatusId;
      this.ReadWrite = item.ReadWrite;
    }
  }
}

export class ModuleProperties {
  public Name: string;
  public Show: boolean;
  public IsMappingEditable: boolean;
  public IsToggleModule: boolean;
}

export interface IModuleAllocation {
  assetMappingConfigurationId: number;
  moduleId: number;
  allocationPercentage: number;
  hasAssets: boolean;
  isToggle: boolean;
  isActiveToggle?: boolean;
  isShow?: boolean;
  hasPendingChange?: boolean;
}